import { useMutation, useQueryClient } from '@tanstack/react-query';
import { groupMembershipMutationFn } from '../../api/write/groupMembership';
import { OFFLINE_MUTATION_DEFAULTS } from '../../lib/mutations/offlineMutationOptions';
import { mutationKeys } from '../../lib/mutations/mutationKeys';
import { assertQueueHasCapacity } from '../../lib/mutations/queueBounds';
import { invalidateAfterGroupMembershipChange } from '../../lib/query/invalidateMutations';

export function useGroupMembershipWrite(userId) {
  const queryClient = useQueryClient();
  const mutationKey = userId ? mutationKeys.groupMembership(userId) : null;

  return useMutation({
    mutationKey,
    scope: mutationKey ? { id: `group-membership-${userId}` } : undefined,
    ...OFFLINE_MUTATION_DEFAULTS,
    mutationFn: groupMembershipMutationFn,
    onMutate: async () => {
      assertQueueHasCapacity(queryClient);
    },
    onSettled: (_data, _err, variables) => {
      if (!userId) return;
      invalidateAfterGroupMembershipChange(queryClient, {
        userId,
        groupId: variables?.groupId,
        eventId: variables?.eventId,
      });
    },
  });
}

export function isGroupMutationQueuedError(error) {
  return error?.code === 'OFFLINE_QUEUE_FULL';
}
